import { useDeviceType, DEVICE_TYPE } from '@libs/common-next';

export const whiteSpaceCalculation = (
    translate: number,
    perViewObject: number,
    gap: number,
    qytTiles: number,
    ignoreWhiteSpace?: boolean
) => {
    const width = window.innerWidth;
    const perView = (width + gap * qytTiles) / perViewObject;
    if (translate < width || ignoreWhiteSpace) {
        return translate;
    }

    const whiteSpacePerView = perView / perViewObject;

    return translate - whiteSpacePerView;
};

export const useWhiteSpaceCalculation = () => {
    const deviceType = useDeviceType();
    if (deviceType !== DEVICE_TYPE.MOBILE) {
        return undefined;
    }
    return whiteSpaceCalculation;
};
